(function (app, ng) {
    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.DigitalMarketing.ConstantContact.CCCampaignInsights",
                    {
                        url: "/CampaignInsights/{ccCampaignId}",
                        params: { ccCampaign: null },
                        component: "ccCampaignInsights",
                        PageTitle: "Constant Contact Campaign Insights | Marketing Tracker",
                        resolve: {
                            onBehalfOfUser: ["userApi", "permissionService", function (userApi, permissionService) {
                                var onBehalfOfUserId = permissionService.getOnBehalfOfUserId();
                                if (onBehalfOfUserId)
                                    return userApi.get(onBehalfOfUserId).catch(ng.noop);
                                return null;
                            }]
                        }
                    });
        }
    ]);

    app.component("ccCampaignInsights",
        {
            templateUrl: "App/Tools/MarketingTrackerNew/DigitalMarketing/ConstantContact/CCCampaignInsights/cc-campaign-insights-template.html",
            controller: ccCampaignInsightsController,
            bindings: {
                user: "<",
                onBehalfOfUser: "<"
            }
        });

    ccCampaignInsightsController.$inject = ["figToaster", "marketingTrackerConstantContactApi", "marketingTrackerContactApi", "$q", "$rootScope", "$scope", "$stateParams", "$timeout", "$window"];
    function ccCampaignInsightsController(figToaster, marketingTrackerConstantContactApi, marketingTrackerContactApi, $q, $rootScope, $scope, $stateParams, $timeout, $window) {
        var $ctrl = this;
        ng.extend($ctrl,
            {
                ui: {
                    loadingData: false,
                    loadingStats: false,
                    reloadingData: false,
                    hasCCToken: false,
                    showPercent: true
                },
                contactList: [],
                toggleSort: toggleSort,
                togglePercent: function () {
                    $ctrl.ui.showPercent = !$ctrl.ui.showPercent;
                },
                propertyName: "first_name",
                resultsPerPageOptions: [
                    { id: 1, count: 25 },
                    { id: 2, count: 50 },
                    { id: 3, count: 100 }
                ],
                refreshData: refreshData,
                connectToConstantContact: connectToConstantContact,
                filters: {
                    sent: {
                        displayName: "Sent",
                        list: [],
                        filter: function (contact) {
                            return $ctrl.filters.sent.list.includes(contact.id);
                        }
                    },
                    delivered: {
                        displayName: "Delivered",
                        list: [],
                        filter: function (contact) {
                            return $ctrl.filters.delivered.list.includes(contact.id);
                        }
                    },
                    opened: {
                        displayName: "Opens",
                        list: [],
                        filter: function (contact) {
                            return $ctrl.filters.opened.list.includes(contact.id);
                        }
                    },
                    unopened: {
                        displayName: "Unopened",
                        list: [],
                        filter: function (contact) {
                            return $ctrl.filters.unopened.list.includes(contact.id);
                        }
                    },
                    clicked: {
                        displayName: "Clicked",
                        list: [],
                        filter: function (contact) {
                            return $ctrl.filters.clicked.list.includes(contact.id);
                        }
                    },
                    optedOut: {
                        displayName: "Opted Out",
                        list: [],
                        filter: function (contact) {
                            return $ctrl.filters.optedOut.list.includes(contact.id);
                        }
                    },
                    bounced: {
                        displayName: "Bounced",
                        list: [],
                        filter: function (contact) {
                            return $ctrl.filters.bounced.list.includes(contact.id);
                        }
                    }
                },
                clearFilter: clearFilter,
                selectFilter: selectFilter,
                selected: {
                    sent: 0,
                    opened: 0,
                    notOpened: 0,
                    clicked: 0,
                    optedOut: 0,
                    spam: 0,
                    bounced: 0,
                    openRate: 0,
                    clickRate: 0,
                    optOutRate: 0,
                    spamRate: 0,
                    bounceRate: 0
                },
                show: {
                    opened: showOpened,
                    notOpened: showNotOpened,
                    bounced: showBounced,
                    clicked: showClicked,
                    optedOut: showOptedOut
                }
            });

        var messageSentChart = false;
        $scope.$on("chart-create", function (event, instance) {
            if (instance.canvas.id === "messageSentChart") {
                messageSentChart = instance;
                $scope.chart = instance.chart;
            }
        });

        function _selectFilter(filter) {
            $ctrl.selectedFilter = filter;
        }

        function _setSelectedCampaign(campaign) {

            var totals = campaign.tracking_summary;
            var delivered = totals.sends - totals.bounces;

            $ctrl.selected = {
                id: campaign.id,
                name: campaign.name,
                chart: {
                    data: [
                        totals.opens,
                        delivered - totals.opens,
                        totals.bounces
                    ],
                    labels: ["Opened", "Not Opened", "Bounced"],
                    backgroundColors: ["#187EEB", "#616161", "#EF5753"],
                    options: {
                        legend: {
                            display: true,
                            position: "left",
                            onHover: function (event) {
                                event.target.style.cursor = "pointer";
                            },
                            //onClick: function(event, label) {
                            //    if (label.text.includes("Bounced")) {
                            //        showBounced();
                            //    } else if (label.text.includes("Not Opened")) {
                            //        showNotOpened();
                            //    } else if (label.text.includes("Opened")) {
                            //        showOpened();
                            //    }
                            //},
                            labels: {
                                generateLabels: function () {
                                    return [
                                        {
                                            text: "Opened (" + totals.opens + ")",
                                            fillStyle: "#187EEB",
                                            hidden: false,
                                            lineWidth: 0,
                                            strokeStyle: "#FFFFFF"
                                        },
                                        {
                                            text: "Not Opened (" + (delivered - totals.opens) + ")",
                                            fillStyle: "#616161",
                                            hidden: false,
                                            lineWidth: 0,
                                            strokeStyle: "#FFFFFF"
                                        },
                                        {
                                            text: "Bounced (" + totals.bounces + ")",
                                            fillStyle: "#EF5753",
                                            hidden: false,
                                            lineWidth: 0,
                                            strokeStyle: "#FFFFFF"
                                        }
                                    ];
                                }
                            }
                        },
                        cutoutPercentage: 55,
                        onHover: function (event) {
                            var active = messageSentChart.getElementsAtEvent(event);
                            if (active.length) {
                                event.target.style.cursor = "pointer";
                            } else event.target.style.cursor = "default";
                        },
                        responsive: true,
                        maintainAspectRatio: false
                    }
                },
                sent: totals.sends,
                opened: totals.opens,
                notOpened: delivered - totals.opens,
                clicked: totals.clicks,
                optedOut: totals.unsubscribes,
                spam: totals.spam_count,
                bounced: totals.bounces,
                openRate: Math.round(totals.opens / delivered * 100),
                clickRate: Math.round(totals.clicks / delivered * 100),
                optOutRate: Math.round(totals.unsubscribes / delivered * 100),
                spamRate: Math.round(totals.spam_count / delivered * 100),
                bounceRate: Math.round(totals.bounces / totals.sends * 100)
            };

            return campaign;
        }

        $scope.loadDataSet = function (elements, e) {
            var pos = Chart.helpers.getRelativePosition(e, $scope.chart);

            var intersect = elements.find(function (element) {
                return element.inRange(pos.x, pos.y);
            });
            if (intersect) {
                var element = intersect._index;

                if (element === 0) {
                    showOpened();
                }
                else if (element === 1) {
                    showNotOpened();
                }
                else if (element === 2) {
                    showBounced();
                }
                $rootScope.$apply();
            }
        };

        function _setCampaignTrackingInfo(campaignTrackingInfo) {
            var distinct = function (value, index, self) {
                return self.indexOf(value) === index;
            };
            campaignTrackingInfo.Opens = campaignTrackingInfo.Opens.filter(distinct);

            var notOpened = function (value) {
                return !campaignTrackingInfo.Opens.includes(value);
            };
            campaignTrackingInfo.DidNotOpen = campaignTrackingInfo.Deliveries.filter(notOpened);

            $ctrl.filters.sent.list = campaignTrackingInfo.Sends;
            $ctrl.filters.delivered.list = campaignTrackingInfo.Deliveries;
            $ctrl.filters.opened.list = campaignTrackingInfo.Opens;
            $ctrl.filters.unopened.list = campaignTrackingInfo.DidNotOpen;
            $ctrl.filters.clicked.list = campaignTrackingInfo.Clicks;
            $ctrl.filters.optedOut.list = campaignTrackingInfo.Unsubscribes;
            $ctrl.filters.bounced.list = campaignTrackingInfo.Bounces;

            return campaignTrackingInfo;
        }

        function _loadCampaignInfo(campaignId) {
            $ctrl.ui.loadingData = true;
            $ctrl.ui.loadingStats = true;
            var message, toastClass = "";
            var promises = [];

            // load Campaign Info
            promises.push($timeout(function () {
                marketingTrackerConstantContactApi.getCampaignById(campaignId)
                    .then(_setSelectedCampaign)
                    .then(function () {

                        marketingTrackerConstantContactApi.getContactsByCampaignId(campaignId)
                            .then(function (response) {
                                if (response) {
                                    $ctrl.contactList = response;
                                } else $ctrl.contactList = [];

                                $ctrl.contactList.forEach(function (contact) {
                                    marketingTrackerContactApi.getContactByConstantContactId(contact.id)
                                        .then(function (figResult) {
                                            contact.figContact = figResult;
                                        });
                                },
                                    this);
                            })
                            .catch(function (error) {
                                console.log("Error: " + error.data);
                                var message = "There was a problem retrieving your data. Please try again shortly.";
                                var toastClass = "is-error";
                                figToaster.showSimple(message, "top", toastClass);
                            })
                            .finally(function () {
                                $ctrl.ui.loadingData = false;
                            });

                    });
            }, 1000));

            // load Campaign Stats
            promises.push($timeout(function () {
                marketingTrackerConstantContactApi.getActivityByCampaignId(campaignId)
                    .then(_setCampaignTrackingInfo)
                    .catch(function (error) {
                        console.log("Error", error.data);
                        message = "There was a problem retrieving your data. Please try again shortly.";
                        toastClass = "is-error";
                        figToaster.showSimple(message, "top", toastClass);
                    })
                    .finally(function () {
                        $ctrl.clearFilter();
                        $ctrl.ui.loadingStats = false;
                    });
            }, 1000));

            $q.all(promises);
        }

        function showOpened() {
            _selectFilter($ctrl.filters.opened);
        }

        function showNotOpened() {
            _selectFilter($ctrl.filters.unopened);
        }

        function showBounced() {
            _selectFilter($ctrl.filters.bounced);
        }

        function showClicked() {
            _selectFilter($ctrl.filters.clicked);
        }

        function showOptedOut() {
            _selectFilter($ctrl.filters.optedOut);
        }

        function selectFilter(filter) {
            _selectFilter(filter);
        }

        function toggleSort(propertyName) {
            $ctrl.reverseOrder = $ctrl.propertyName === propertyName ? !$ctrl.reverseOrder : false;
            $ctrl.propertyName = propertyName;
        }

        function clearFilter() {
            _selectFilter($ctrl.filters.sent);
        }

        function refreshData() {
            $ctrl.clearFilter();
            _loadCampaignInfo($ctrl.selected.id);
        }

        function connectToConstantContact() {
            marketingTrackerConstantContactApi.postConnect()
                .then(function (response) {
                    console.log('Get Authentication URL from Marketing Tracker' + response);
                    $window.open(response.Url, '_blank');
                });
        }

        $ctrl.$onInit = function () {
            $ctrl.clearFilter();
            $ctrl.resultsPerPage = $ctrl.resultsPerPageOptions[1];

            marketingTrackerConstantContactApi.getHasToken()
                .then(function (hasToken) {
                    if (hasToken) {
                        $ctrl.ui.hasCCToken = true;
                    }
                })
                .then(function () {
                    _loadCampaignInfo($stateParams.ccCampaignId);
                });
        };
    }

})(window.app, window.angular); //jshint ignore:line